import React from 'react'
import t from '../i18n/translations/translations'

export default function AcceptPolicyLabelInstance77({ lang, instanceId  }) {
  const isEs = lang === 'es'

  return (
    <p>
      {isEs ? (
        <>
          He leído y acepto la{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.plentzia.eus/es-ES/Institucional/Paginas/politica-privacidad.aspx"
          >
            política de privacidad
          </a>
          , la{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.plentzia.eus/es-ES/Institucional/Paginas/informacion-adicional.aspx"
          >
            protección de datos
          </a>
          {' '}y la{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.plentzia.eus/es-ES/Institucional/Paginas/Cookies.aspx"
          >
            política de cookies
          </a>
          .
        </>
      ) : (
        <>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.plentzia.eus/eu-ES/Erakundeetakoa/Orriak/politica-privacidad.aspx"
          >
            pribatutasun-politika
          </a>
          ,{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.plentzia.eus/eu-ES/Erakundeetakoa/Orriak/informacion-adicional.aspx"
          >
            datu-babesaren informazio osagarria
          </a>
          {' '}eta{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.plentzia.eus/eu-ES/Erakundeetakoa/Orriak/Cookieak.aspx"
          >
            cookieen politika
          </a>
          {' '}irakurri eta onartzen ditut.
        </>
      )}
    </p>
  )
}